<template>
  <div>
    <base-data-table
      :items="clientPortals.data"
      :serverItemsLength="clientPortals.total"
      :nbItemsByPage="NB_ITEMS_BY_PAGE"
      :loading="isLoading"
      :options.sync="options"
      :headers="headers"
      containerId="#table-portails-container"
      itemClickRouterTarget="portail-details"
      :fixedHeaders="fixedHeaders"
      class="table-cursor"
    >
      <template v-slot:item.portal="{ item }">
        <span v-if="item.portal == 3">V5</span>
        <span v-else-if="item.portal == 2">V4</span>
        <span v-else-if="item.portal == 1">V3</span>
        <span v-else>V2</span>
      </template>

      <template v-slot:item.isInherit="{ item }">
        <v-icon v-if="item.isInherit" color="black">mdi-check</v-icon>
        <span v-else></span>
      </template>

      <template v-slot:item.nas="{ item }">
        {{ item.nas.length }}
      </template>

      <template v-slot:item.isActive="{ item }">
        <span
          v-if="item.isActive == true && item.isSandboxModeActive == true"
          class="orange--text"
        >
          Sandbox
        </span>
        <span
          v-else-if="item.isActive == true && item.isSandboxModeActive == false"
          class="green--text"
        >
          Actif
        </span>
        <span v-else-if="item.isActive == false" class="red--text"
          >Inactif</span
        >
      </template>

      <template v-slot:item.updatedAt="{ item }">
        {{ getInternationalDate(item.updatedAt) }}
      </template>
    </base-data-table>
  </div>
</template>
<script>
import { date } from "@/composables/date";
import { useClientPortal } from "../../composables/client-portal";
import { onMounted, toRefs, watch } from "@vue/composition-api";
import BaseDataTable from "@/components/General/BaseDataTable.vue";

export default {
  components: {
    BaseDataTable,
  },
  props: {
    filterParams: Object,
    searchTerm: String,
    fixedHeaders: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const { getInternationalDate } = date();
    const { data, listClientPortals } = useClientPortal();

    /* Variables */
    const NB_ITEMS_BY_PAGE = 100;

    /* Méthodes */
    const handleClass = (item) => {
      if (item.isActive == true && item.isSandboxModeActive == true) {
        return "sandboxedRow";
      } else if (item.isActive == true && item.isSandboxModeActive == false) {
        return true;
      }
      if (item.isActive == false) {
        return "notActiveRow";
      }
    };

    /* Watchers */
    watch(
      [() => data.options, () => props.filterParams],
      async (newValues, oldValues) => {
        if (oldValues[0].page !== undefined) {
          await listClientPortals(props.filterParams, props.searchTerm);
          emit("display:nb-portails", data.clientPortals.total);
        }
      },
      {
        deep: true,
      }
    );

    /* Cycle de vie */
    onMounted(async () => {
      await listClientPortals(props.filterParams, props.searchTerm);
      emit("display:nb-portails", data.clientPortals.total);
      emit("fetch-records", data.clientPortals.data);
    });

    return {
      ...toRefs(data),
      headers: [
        { text: "ID Passman", value: "passmanId" },
        { text: "ID Externe", value: "reference" },
        { text: "Description", value: "description" },
        { text: "Version", value: "portal" },
        { text: "Héritage", value: "isInherit", sortable: false },
        { text: "Etat", value: "isActive" },
        { text: "NAS", value: "nas", sortable: false },
        { text: "Editeur", value: "updatedBy" },
        { text: "Modifié le", value: "updatedAt" },
      ],
      handleClass,
      getInternationalDate,
      NB_ITEMS_BY_PAGE,
    };
  },
};
</script>
<style scoped>
.sandboxedRow {
  background-color: rgba(255, 255, 0, 0.2);
}
.notActiveRow {
  background-color: rgba(255, 0, 0, 0.2);
}
.table-cursor::v-deep tbody {
  cursor: pointer;
}
</style>
